import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ArrowUpperRightIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 25" {...props}>
            <g clipPath="url(#clip0_101_6990)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.2874 5.45747C19.8397 5.45747 20.2874 5.90518 20.2874 6.45747L20.2874 16.357C20.2874 16.9092 19.8397 17.357 19.2874 17.357C18.7351 17.357 18.2874 16.9092 18.2874 16.357L18.2874 8.87168L7.26658 19.8925C6.87605 20.283 6.24289 20.283 5.85237 19.8925C5.46184 19.502 5.46184 18.8688 5.85237 18.4783L16.8732 7.45747H9.3879C8.83561 7.45747 8.3879 7.00975 8.3879 6.45747C8.3879 5.90518 8.83561 5.45747 9.3879 5.45747H19.2874Z"
                />
            </g>
            <defs>
                <clipPath id="clip0_101_6990">
                    <rect width="24" height="24" transform="translate(0.92334 0.821411)" />
                </clipPath>
            </defs>
        </SvgIcon>
    );
};

export default ArrowUpperRightIcon;
